module.exports = __webpack_public_path__ + "img/r2.025ebfd8.jpg";